import { isPlainObject as isPlainObjectFunction } from "is-plain-object";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RecordKey = keyof any;

/**
 * Checks whether the value is a plain object
 *
 * A plain object is an object with properties that is not an instance of a class.
 */
export function isPlainObject(value: unknown): value is Record<RecordKey, unknown> {
    return isPlainObjectFunction(value);
}

/**
 * Checks whether the value is a record (an object with properties).
 */
export function isRecord(value: unknown): value is Record<RecordKey, unknown> {
    return (
        value !== undefined &&
        value !== null &&
        (typeof value === "object" || typeof value === "function") &&
        !Array.isArray(value)
    );
}

/**
 * Copy the values of all of the enumerable own properties from one or more source objects to a
 * target object only if the source value is not undefined. Returns the target object.
 *
 * @param target The target object to copy to.
 * @param source The source object from which to copy properties.
 */
export function assignIfDefined<T>(target: T, source: Partial<T>): T {
    for (const [propertyName, propertyValue] of Object.entries(source as Record<string, unknown>)) {
        if (propertyValue !== undefined) {
            (target as Record<string, unknown>)[propertyName] = propertyValue;
        }
    }

    return target;
}
